/**
 * @module config/layout
 * @description Card layout mode: whether postcards keep their print
 * (landscape) layout on every screen, or turn portrait on phones.
 *
 * "adaptive" is Jason's proposal for phone legibility (Session 1B), shown
 * to Samantha on its own preview deploy for separate approval. Print and
 * PDF output are always landscape: they are postcards.
 */
export type CardLayoutMode = "landscape" | "adaptive";

/** At or below this viewport width, adaptive cards switch to portrait. */
export const PORTRAIT_MAX_WIDTH_PX = 640;

export const DEFAULT_CARD_LAYOUT: CardLayoutMode = "landscape";

export const isCardLayoutMode = (value: unknown): value is CardLayoutMode => value === "landscape" || value === "adaptive";
